export const PRISMIC_QUERY_KEY_PREFIX = 'PRISMIC';
export const PRISMIC_REF_QUERY_KEY = [PRISMIC_QUERY_KEY_PREFIX, 'REF'];
export const PRISMIC_HOST = window.__DPL_PRISMIC_HOST;
export const PRISMIC_REF_URL = `${PRISMIC_HOST}/api/v2`;
export const PRISMIC_SEARCH_URL = `${PRISMIC_REF_URL}/documents/search`;

export const BYPASSED_HUB_UIDS = window.__DPL_PRISMIC_BYPASSED_HUB_UIDS || [];
export const PRISMIC_PREVIEW_COOKIE = 'io.prismic.preview';
